/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetAllAssetPricesStatus200,
  GetAllAssetPricesStatus500,
} from '../types/GetAllAssetPrices'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getAllAssetPrices } from '../clients/getAllAssetPrices'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAllAssetPricesQueryKey = () => [{ url: '/v1/price' }] as const

type GetAllAssetPricesQueryKey = ReturnType<typeof getAllAssetPricesQueryKey>

export function getAllAssetPricesQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getAllAssetPricesQueryKey()
  return queryOptions<
    GetAllAssetPricesStatus200,
    ResponseErrorConfig<GetAllAssetPricesStatus500>,
    GetAllAssetPricesStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getAllAssetPrices({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get the current price of all assets
 * {@link /v1/price}
 */
export function useGetAllAssetPrices<
  TData = GetAllAssetPricesStatus200,
  TQueryData = GetAllAssetPricesStatus200,
  TQueryKey extends QueryKey = GetAllAssetPricesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetAllAssetPricesStatus200,
        ResponseErrorConfig<GetAllAssetPricesStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getAllAssetPricesQueryKey()

  const queryResult = useQuery(
    {
      ...getAllAssetPricesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetAllAssetPricesStatus500>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
